export class Sollstunden {
  constructor({
    aushilfen,
    festangestellte,
  }: {
    readonly aushilfen: number;
    readonly festangestellte: number;
  }) {
    this.aushilfen = aushilfen;
    this.festangestellte = festangestellte;
  }

  readonly aushilfen: number;
  readonly festangestellte: number;
}
